import { qcAxios } from '../../api/axiosQcClient';

const API_PREFIX = '/api';

function normalizeUsersResponse(body) {
  const d = body?.data ?? body;
  if (Array.isArray(d)) return d;
  const nested = body?.data?.data ?? body?.data?.rows;
  if (Array.isArray(nested)) return nested;
  return [];
}

/**
 * Fetch all users for assignment filters/autocomplete.
 * Endpoint: `GET /api/userData/getAllUsers?search=<term>`
 *
 * Response is normalized to an array of user objects.
 */
export async function getAllUsers(search) {
  const term = search == null ? '' : String(search).trim();
  const { data: body } = await qcAxios.get(
    `${API_PREFIX}/userData/getAllUsers`,
    {
      params: { search: term },
    },
  );
  return normalizeUsersResponse(body);
}

